<template>
  <reactive-style v-if="visible" :class="[baseCss]">
  html {
    filter: sepia({{ temperature }}%);
  }
  </reactive-style>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Nightshift',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('nightshift')
    }
  },
  props: {
    temperature: {
      type: Number,
      default: 65
    },
    visible: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/nightshift/nightshift.vue